export default __webpack_public_path__ + "kickstartericonn.6acda9.png";